import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import createReactClass from 'create-react-class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo } from '@fortawesome/free-solid-svg-icons'

import { GetText } from 'lib/gettext'
import Region from 'legacy/apps/region/components/region'

import POLYGON_TOOL_ICON from 'legacy/assets/images/icon-polygon.svg'

import s from './editable-gis-region.module.scss'

export default createReactClass({
  displayName: 'EditableRegion',

  propTypes: {
    onClearClick: PropTypes.func,
  },

  onClearMapClick() {
    this.refs.editableRegion.clearMap()

    if (_.isFunction(this.props.onClearClick)) {
      this.props.onClearClick()
    }
  },

  redraw(wkt) {
    if (_.isUndefined(wkt)) {
      this.refs.editableRegion.redraw()
    } else {
      this.refs.editableRegion.redraw(undefined, { wkt })
    }
  },

  render() {
    return (
      <div>
        <div className={s.content}>
          <div className={s.instructions}>
            <div className={s.instruction}>
              <GetText
                components={{
                  icon: (
                    <img
                      src={POLYGON_TOOL_ICON}
                      className="inline-block"
                      alt="polygon icon"
                    />
                  ),
                }}
              >
                Use the polygon tool [icon/] to plot points on the map and
                create your region.
              </GetText>
            </div>

            <span className={s.clear__map} onClick={this.onClearMapClick}>
              <FontAwesomeIcon icon={faUndo} />
              <GetText>Clear map</GetText>
            </span>
          </div>
        </div>

        <div className={s.map}>
          <Region ref="editableRegion" editable {...this.props} />
        </div>
      </div>
    )
  },
})
